import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'drr-tow-location-map-controls',
  templateUrl: './tow-location-map-controls.component.html',
  styleUrls: ['./tow-location-map-controls.component.scss']
})
export class TowLocationMapControlsComponent {
  @Input() isShopsCarouselVisible = true;
  @Output() showShopCards = new EventEmitter<boolean>();
  @Output() viewList = new EventEmitter<void>();

  handleShowShopCards(show: boolean): void {
    this.showShopCards.emit(show);
  }

  handleViewList(): void {
    this.viewList.emit();
  }
}
